import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedTeam = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="users" size="100%" color={stroke ?? color} />
);

export { LineRoundedTeam };
